<template>
  <div>
    <div class="header">
      <b-alert variant="info" :show="message != null">{{message}}</b-alert>
      <b-alert variant="danger" :show="error != null">{{error}}</b-alert>
    </div>
    <div class="container-fluid">
      <div class="p-2 border-bottom border-info">
        <h4 class="text-info font-italic">
          <strong>体組成計測定待ち</strong>
          <span class="ml-2"><b-btn size="sm" variant="info" @click="refreshItems"><i class="fas fa-sync"/> 再読込</b-btn></span>
        </h4>
      </div>
      <div>
        <b-table striped hover :fields="table.fields" :items="list" :options="table.options" class="users-table">
          <template slot="member" slot-scope="data">
            <span v-if="!data.item.userNo || data.item.user_id === '0'"><b class="text-danger">未設定</b></span>
            <span v-else><b-btn variant="link" @click="linkUser(data.item)"><b>{{data.item.userNo}}</b></b-btn></span>
          </template>
          <template slot="lastModifiedAt" slot-scope="data">
            {{ formatDateTime(data.item.lastModifiedAt) }}
          </template>
        </b-table>
      </div>
    </div>
    <hr>
    <div class="mb-2">
      <b-btn variant="secondary" block @click="$router.push('/usergroups/' + $store.getters.currentUserGroup.groupId + '/top')">
        <span>戻る</span>
      </b-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import { Logger } from 'aws-amplify'

const logger = new Logger('UserFelicaSettings')

export default {
  name: 'UserFelicaSettings',
  data () {
    return {
      processing: false,
      message: null,
      error: null,
      list: [],
      table: {
        fields: [
          {
            key: 'name',
            label: 'カード名'
          },
          {
            key: 'member',
            label: 'ID番号'
          },
          {
            key: 'lastModifiedAt',
            label: '更新日時'
          }
        ]
      }
    }
  },
  computed: {
    today () {
      return moment().tz('Asia/Tokyo').format('MM/DD')
    },
    currentUserGroup () {
      return this.$store.getters.currentUserGroup
    }
  },
  mounted () {
    this.loadItems()
  },
  methods: {
    formatTime (time) {
      return moment(time).format('MM/DD HH:mm:ss')
    },
    formatDateTime (time) {
      return moment(time, 'x').format('MM/DD HH:mm')
    },
    loadItems () {
      this.loading = true
      this.error = null
      this.$store.dispatch('fetchUserFelicas').then(userFelicas => {
        let uf = userFelicas.filter(uf => uf.groupId === this.currentUserGroup.groupId)
        logger.debug(uf)
        this.list = uf
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.message = null
        logger.error(err)
        this.error = err.message || err
      })
    },
    refreshItems () {
      this.message = null
      this.loadItems()
    },
    linkUser (userFelica) {
      this.$router.push('/usergroups/' + userFelica.groupId + '/users/' + userFelica.user_id)
    },
    onRegister (item) {
      if (!this.currentUserGroup) {
        this.error = '測定会を設定してください'
        return
      }
      logger.debug(item)
      this.loading = true
      this.message = null
      this.error = null
      return this.$store.dispatch('createUserFelica', { userGroup: this.currentUserGroup, idm: this.idm(item.Key) }).then(() => {
        this.loading = false
        this.message = '登録しました'
        return this.onDelete(item)
      }).then(() => {
        this.refreshItems()
      }).catch(err => {
        this.loading = false
        this.message = null
        logger.error(err)
        this.error = err.message || err
      })
    },
    onDelete (item) {
    },
    translateLocalMessage (error) {
      return {
        'AccessDeniedException': '不正なアクセスです。再ログインしてください(S)',
        'ValidationException': '不正パラメタです。'
      }[error.code] || error.message
    }
  }
}
</script>

<style scoped>
</style>
